import {
  DashboardOutlined,
  TeamOutlined,
  SettingOutlined,
  PieChartOutlined,
  UnorderedListOutlined,
  EnvironmentOutlined,
  BankOutlined,
  AppstoreOutlined,
  InsertRowBelowOutlined,
  BarChartOutlined,
  ReloadOutlined,
  CreditCardOutlined,
  LogoutOutlined,
  ClusterOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH, TILL_PREFIX_PATH } from "configs/AppConfig";
import { ADMIN_ROLES } from "constants/RoleConstant";
import { cookieGETAdminRole } from "cookie/general";

const role = cookieGETAdminRole();
const canViewProducts =
  role === ADMIN_ROLES.ADMIN ||
  role === ADMIN_ROLES.WAREHOUSE ||
  role === ADMIN_ROLES.MANAGER;
const dashBoardNavTree =
  role === ADMIN_ROLES.ADMIN
    ? [
        {
          key: "dashboards",
          path: `${APP_PREFIX_PATH}/dashboards`,
          title: "sidenav.dashboard",
          icon: DashboardOutlined,
          breadcrumb: false,
          submenu: [],
        },
      ]
    : [];

const tillNavTree = [
  {
    key: "till",
    path: `${TILL_PREFIX_PATH}/login`,
    title: "sidenav.till",
    icon: LogoutOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const setupNavTree =
  role === ADMIN_ROLES.ADMIN
    ? [
        {
          key: "setup",
          path: `${APP_PREFIX_PATH}/setup`,
          title: "sidenav.setup",
          icon: SettingOutlined,
          breadcrumb: false,
          submenu: [
            // Company
            {
              key: "setup-company",
              path: `${APP_PREFIX_PATH}/setup/company/details`,
              title: "sidenav.setup.company",
              icon: TeamOutlined,
              breadcrumb: false,
              submenu: [
                {
                  key: "setup-company-discount",
                  path: `${APP_PREFIX_PATH}/setup/company/discount`,
                  title: "sidenav.setup.company.discount",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
              ],
            },
            // Locations
            {
              key: "setup-locations",
              path: `${APP_PREFIX_PATH}/setup/locations`,
              title: "sidenav.setup.locations",
              icon: EnvironmentOutlined,
              breadcrumb: false,
              submenu: [
                {
                  key: "setup-locations-devices",
                  path: `${APP_PREFIX_PATH}/setup/locations/branches`,
                  title: "sidenav.setup.locations.branches",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
              ],
            },
            // Banking
            {
              key: "setup-banking",
              path: `${APP_PREFIX_PATH}/setup/banking`,
              title: "sidenav.setup.banking",
              icon: BankOutlined,
              breadcrumb: true,
              submenu: [
                {
                  key: "setup-banking-tender-types",
                  path: `${APP_PREFIX_PATH}/setup/banking/tender-types`,
                  title: "sidenav.setup.banking.tender",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
                {
                  key: "setup-banking-tax-rates",
                  path: `${APP_PREFIX_PATH}/setup/banking/tax-rates`,
                  title: "sidenav.setup.banking.tax",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
              ],
            },
          ],
        },
      ]
    : [];

const manageNavTree = [
  {
    key: "manage",
    path: `${APP_PREFIX_PATH}/manage`,
    title: "sidenav.manage",
    icon: UnorderedListOutlined,
    breadcrumb: false,
    submenu: [
      // PRODUCTS
      ...(canViewProducts
        ? [
            {
              key: "manage-products",
              path: `${APP_PREFIX_PATH}/manage/products`,
              title: "sidenav.manage.products",
              icon: InsertRowBelowOutlined,
              breadcrumb: false,
              submenu: [
                {
                  key: "manage-products-list",
                  path: `${APP_PREFIX_PATH}/manage/products/list`,
                  title: "sidenav.manage.products.list",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
                {
                  key: "manage-products-low-stock",
                  path: `${APP_PREFIX_PATH}/manage/products/low-stock`,
                  title: "sidenav.manage.products.lowStock",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
                {
                  key: "manage-products-phones",
                  path: `${APP_PREFIX_PATH}/manage/products/phones`,
                  title: "sidenav.manage.products.phones",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
                {
                  key: "manage-products-category",
                  path: `${APP_PREFIX_PATH}/manage/products/category`,
                  title: "sidenav.manage.products.categories",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
                // Temporary: remove once the colour merge is done.
                {
                  key: "manage-products-merge-colours",
                  path: `${APP_PREFIX_PATH}/manage/products/merge-colours`,
                  title: "sidenav.manage.products.mergeColours",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
              ],
            },
          ]
        : []),

      // STOCK CONTROL
      ...(role !== ADMIN_ROLES.WAREHOUSE &&
      role !== ADMIN_ROLES.MANAGER &&
      role !== ADMIN_ROLES.ADMIN
        ? []
        : [
            {
              key: "manage-stock-control",
              path: `${APP_PREFIX_PATH}/manage/stock`,
              title: "sidenav.manage.stock",
              icon: AppstoreOutlined,
              breadcrumb: false,
              submenu: [
                {
                  key: "manage-stock-control-orders",
                  path: `${APP_PREFIX_PATH}/manage/stock/orders`,
                  title: "sidenav.manage.stock.orders",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
                {
                  key: "manage-stock-control-history",
                  path: `${APP_PREFIX_PATH}/manage/stock/history`,
                  title: "sidenav.manage.stock.history",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
              ],
            },
          ]),

      // STAFF
      ...(role === ADMIN_ROLES.WAREHOUSE
        ? []
        : [
            {
              key: "manage-staff",
              path: `${APP_PREFIX_PATH}/manage/staff`,
              title: "sidenav.manage.staff",
              icon: TeamOutlined,
              breadcrumb: false,
              submenu: [
                ...(role === ADMIN_ROLES.ADMIN
                  ? [
                      {
                        key: "manage-staff-admin",
                        path: `${APP_PREFIX_PATH}/manage/staff/admin`,
                        title: "sidenav.manage.staff.admin",
                        icon: "",
                        breadcrumb: false,
                        submenu: [],
                      },
                    ]
                  : []),
                {
                  key: "manage-staff-staff",
                  path: `${APP_PREFIX_PATH}/manage/staff/staff`,
                  title: "sidenav.manage.staff.staff",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
              ],
            },
          ]),

      ...(role === ADMIN_ROLES.WAREHOUSE ||
      role === ADMIN_ROLES.ADMIN ||
      role === ADMIN_ROLES.MANAGER
        ? [
            {
              key: "manage-warehouse",
              path: `${APP_PREFIX_PATH}/manage/warehouse`,
              title: "sidenav.manage.warehouse",
              icon: ClusterOutlined,
              breadcrumb: true,
              submenu: [
                {
                  key: "manage-warehouse-orders",
                  path: `${APP_PREFIX_PATH}/manage/warehouse/orders`,
                  title: "sidenav.manage.warehouse.orders",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
                {
                  key: "manage-warehouse-stock",
                  path: `${APP_PREFIX_PATH}/manage/warehouse/stock`,
                  title: "sidenav.manage.warehouse.stock",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
                {
                  key: "manage-warehouse-products",
                  path: `${APP_PREFIX_PATH}/manage/warehouse/products`,
                  title: "sidenav.manage.warehouse.products",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
              ],
            },
          ]
        : []),
    ],
  },
];

const reportingNavTree =
  role !== ADMIN_ROLES.WAREHOUSE
    ? [
        {
          key: "reporting",
          path: `${APP_PREFIX_PATH}/reporting`,
          title: "sidenav.reporting",
          icon: PieChartOutlined,
          breadcrumb: false,
          submenu: [
            {
              key: "reporting-transactions",
              path: `${APP_PREFIX_PATH}/reporting/transactions`,
              title: "sidenav.reporting.transaction",
              icon: CreditCardOutlined,
              breadcrumb: false,
              submenu: [
                {
                  key: "reporting-transactions-completed",
                  path: `${APP_PREFIX_PATH}/reporting/transactions-completed`,
                  title: "sidenav.reporting.transaction.completed",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
              ],
            },
            {
              key: "reporting-sales",
              path: `${APP_PREFIX_PATH}/reporting/sales`,
              title: "sidenav.reporting.sales",
              icon: BarChartOutlined,
              breadcrumb: false,
              submenu: [
                {
                  key: "reporting-sales-period",
                  path: `${APP_PREFIX_PATH}/reporting/sales/period`,
                  title: "sidenav.reporting.sales.period",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
                {
                  key: "reporting-sales-product",
                  path: `${APP_PREFIX_PATH}/reporting/sales/product`,
                  title: "sidenav.reporting.sales.sales",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
                {
                  key: "reporting-sales-locations",
                  path: `${APP_PREFIX_PATH}/reporting/sales/locations`,
                  title: "sidenav.reporting.sales.locations",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
                {
                  key: "reporting-sales-categories",
                  path: `${APP_PREFIX_PATH}/reporting/sales/categories`,
                  title: "sidenav.reporting.sales.categories",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
                {
                  key: "reporting-sales-till-categories",
                  path: `${APP_PREFIX_PATH}/reporting/sales/till-categories`,
                  title: "sidenav.reporting.sales.till-categories",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
              ],
            },
            {
              key: "reporting-stock",
              path: `${APP_PREFIX_PATH}/reporting/stock`,
              title: "sidenav.reporting.stock",
              icon: AppstoreOutlined,
              breadcrumb: false,
              submenu: [
                {
                  key: "reporting-stock-levels",
                  path: `${APP_PREFIX_PATH}/reporting/stock/levels`,
                  title: "sidenav.reporting.stock.levels",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
              ],
            },
            {
              key: "reporting-banking",
              path: `${APP_PREFIX_PATH}/reporting/banking`,
              title: "sidenav.reporting.banking",
              icon: BankOutlined,
              breadcrumb: false,
              submenu: [
                {
                  key: "reporting-banking-tenders",
                  path: `${APP_PREFIX_PATH}/reporting/banking/tenders`,
                  title: "sidenav.reporting.banking.tenders",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
              ],
            },
            {
              key: "reporting-auditing",
              path: `${APP_PREFIX_PATH}/reporting/auditing`,
              title: "sidenav.reporting.auditing",
              icon: ReloadOutlined,
              breadcrumb: false,
              submenu: [
                {
                  key: "reporting-auditing-refunds",
                  path: `${APP_PREFIX_PATH}/reporting/auditing/refunds`,
                  title: "sidenav.reporting.auditing.refunds",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
                {
                  key: "reporting-auditing-discounts",
                  path: `${APP_PREFIX_PATH}/reporting/auditing/discounts`,
                  title: "sidenav.reporting.auditing.discounts",
                  icon: "",
                  breadcrumb: false,
                  submenu: [],
                },
              ],
            },
          ],
        },
      ]
    : [];

const navigationConfig = [
  ...dashBoardNavTree,
  ...tillNavTree,
  ...setupNavTree,
  ...manageNavTree,
  ...reportingNavTree,
];

export default navigationConfig;
